import React from 'react';
import DespesasPage from './DespesasPage';

export default function CaixaPage() {
  return (
    <div className="animate-in fade-in duration-300">
      <DespesasPage />
    </div>
  );
}
